import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

export const Wrapper = styled.div`
  position: relative;
  height: 290px;
`;

export const Header = styled.header`
  border-bottom: 1px solid transparent;
  border-color: #ddd;
  color: #000;
  font-weight: 600;
  text-transform: capitalize;
  padding: 15px 10px 5px 10px;
  margin: 0 20px;
  display: flex;
  justify-content: space-between;
  overflow: hidden;

  .panel-title {
    font-size: 1em;
    display: flex;
    justify-content: space-between;
    position: relative;
  }

  ${mediaMaxWidth.tablet} {
    background: #fff !important;
    padding: 5px 0;
    flex-direction: column !important;

    .panel-title {
      padding: 20px 15px 5px 15px;
      color: #525252;
      background: #ffffff;
      text-align: left;
      border-top: 2px solid #fff;
      letter-spacing: 1px;
      width: calc(100vw - 40px) !important;
      margin-top: -10px;
      margin-left: -15px;
      font-size: 0.875em;
    }
  }
`;

export const MemberSince = styled.div`
  font-size: 0.75em;
  text-transform: none;
  display: flex;
  align-items: center;
  color: #8e8e8e;
  font-weight: 500;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 10px;
  right: 20px;
  width: 120px;
  text-align: right;
  line-height: 1.1em;

  ${mediaMinWidth.mediumScreen} {
    width: 220px;
    top: 20px;
    right: 0;
  }

  ${mediaMaxWidth.phone} {
    letter-spacing: 0;
  }
`;

export const Body = styled.div`
  padding: 5px 15px;
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  margin: 15px 0;

  ${mediaMaxWidth.phone} {
    flex-wrap: wrap;
  }
`;

interface IColumnProps {
  flex: number;
  noMobile?: boolean;
}

export const Column = styled.div`
  display: flex;
  flex-direction: column;
  flex: ${(props: IColumnProps) => props.flex};
  align-items: center;

  svg {
    position: relative;
    color: #bbbbbb;
    top: 14px;
  }

  svg.fa-chevron-right {
    top: 6px;
  }

  svg.fa-info-circle {
    top: 6px;
    font-size: 0.8em;
  }

  ${mediaMaxWidth.phone} {
    display: ${(props: IColumnProps) => props.noMobile && "none"};
    padding: 0 15px;
  }
`;

interface INumberProps {
  fontSize: string;
}

export const Number = styled.div`
  display: flex;
  font-size: ${(props: INumberProps) => props.fontSize === "large" && "1.7em"};
  font-size: ${(props: INumberProps) => props.fontSize === "medium" && "1.2em"};
  position: relative;
  left: ${(props: INumberProps) => props.fontSize === "large" && "-9px"};
`;

export const InfoDot = styled.div`
  svg {
    font-size: 0.4em !important;
    position: absolute;
    top: 18px !important;
    right: -20px !important;
    color: #bbbbbb !important;
    transition: 0.1s ease-in-out;

    ${mediaMaxWidth.phone} {
      top: 15px !important;
      right: -17.5px !important;
    }
  }
`;

export const Description = styled.div`
  display: flex;
  font-size: 0.9em;
  letter-spacing: 0.02em;
  margin: 10px 0;
  text-align: center;
  max-width: 90px;

  ${mediaMaxWidth.phone} {
    font-size: 0.8em;
    margin: 10px 0;
  }
`;
